"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFromCollection = exports.addAndRemoveFromCollection = void 0;
var collection_1 = require("@shopify/app-bridge-core/util/collection");
Object.defineProperty(exports, "addAndRemoveFromCollection", { enumerable: true, get: function () { return collection_1.addAndRemoveFromCollection; } });
Object.defineProperty(exports, "removeFromCollection", { enumerable: true, get: function () { return collection_1.removeFromCollection; } });



//////////////////
// WEBPACK FOOTER
// ./node_modules/@shopify/app-bridge/util/collection.js
// module id = KOMw
// module chunks = 0